module.exports = __webpack_public_path__ + "static/img/nodata01.e5940a0c.png";